import { render, staticRenderFns } from "./tokenAddress.vue?vue&type=template&id=61269690&"
import script from "./tokenAddress.vue?vue&type=script&lang=js&"
export * from "./tokenAddress.vue?vue&type=script&lang=js&"
import style0 from "./tokenAddress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports